import isObject from 'lodash-es/isObject'

import { EMPTY_LIST } from '../../../constants/common'

export function getNextMultiSelectValue(prevValue, option) {
  if (!option) {
    return prevValue || EMPTY_LIST
  }

  if (
    prevValue?.find?.(prevValueItem => prevValueItem.value === option.value)
  ) {
    return prevValue.filter(
      prevValueItem => prevValueItem.value !== option.value
    )
  } else {
    return [...(prevValue || EMPTY_LIST), option]
  }
}

export function getNextMultiSelectAllValue(
  prevValue = EMPTY_LIST,
  nextValue = EMPTY_LIST
) {
  const existingValueKeys = new Set(prevValue.map(item => item?.value))

  const nextItems = nextValue.filter(
    item => !existingValueKeys.has(item?.value)
  )

  return [...prevValue, ...nextItems]
}

export function getFormFieldSelectValidValue(value) {
  return isObject(value) ? value : null
}
